import React from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";

const AdminLanguages = () => {
  return (
    <>
      <div className="main-wrapper">
        <Header />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="row">
              <div className="col-xl-12 col-12">
                <div className="card rounded-1 card-table">
                  <div className="card-header py-3">
                    <div className="row">
                      <div className="col">
                        <h5 className="card-title">All Languages</h5>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="row m-3 justify-content-between">
                      <div className="col-md-4">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search Languages"
                        />
                      </div>
                      <div className="col-auto">
                        <a
                          href="careate-languages.html"
                          className="btn btn-primary"
                        >
                          Create Language
                        </a>
                      </div>
                    </div>
                    <div
                      className="table-responsive"
                      style={{ scrollbarWidth: "thin" }}
                    >
                      <table className="table table-striped table-hover">
                        <thead className="thead-light">
                          <tr>
                            <th>Cover</th>
                            <th>Default</th>
                            <th>Name</th>
                            <th>Status</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              <img
                                src="assets/img/flags/us.png"
                                alt=""
                                width="40"
                                height="40"
                              />
                            </td>
                            <td>
                              <input
                                className="form-check-input"
                                checked
                                type="radio"
                                name="flexRadioDefault"
                                id="flexRadioDefault1"
                              />
                            </td>
                            <td>English</td>
                            <td>
                              <span className="badge bg-success">Active</span>
                            </td>
                            <td>
                              <button className="btn btn-primary btn-sm">
                                view
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <img
                                src="assets/img/flags/fr.png"
                                alt=""
                                width="40"
                                height="40"
                              />
                            </td>
                            <td>
                              <input
                                type="radio"
                                className="form-check-input"
                                name="flexRadioDefault"
                                id="flexRadioDefault2"
                              />
                            </td>
                            <td>Frensh</td>
                            <td>
                              <span className="badge bg-success">Active</span>
                            </td>
                            <td>
                              <button className="btn btn-primary btn-sm">
                                view
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <img
                                src="assets/img/flags/es.png"
                                alt=""
                                width="40"
                                height="40"
                              />
                            </td>
                            <td>
                              <input
                                type="radio"
                                className="form-check-input"
                                name="flexRadioDefault"
                                id="flexRadioDefault3"
                              />
                            </td>
                            <td>Spanish</td>
                            <td>
                              <span className="badge bg-success">Active</span>
                            </td>
                            <td>
                              <button className="btn btn-primary btn-sm">
                                view
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <img
                                src="assets/img/flags//de.png"
                                alt=""
                                width="40"
                                height="40"
                              />
                            </td>
                            <td>
                              <input
                                type="radio"
                                className="form-check-input"
                                name="flexRadioDefault"
                                id="flexRadioDefault3"
                              />
                            </td>
                            <td>Garman</td>
                            <td>
                              <span className="badge bg-success">Active</span>
                            </td>
                            <td>
                              <button className="btn btn-primary btn-sm">
                                view
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="card-footer">
                    <div className="d-flex flex-column flex-sm-row align-items-center justify-content-between">
                      <p className="text-dark">Showing 1 to 3 of 20 entries</p>
                      <nav aria-label="...">
                        <ul className="pagination">
                          <li className="page-item disabled">
                            <a className="page-link" href="#" tabindex="-1">
                              Previous
                            </a>
                          </li>
                          <li className="page-item">
                            <a className="page-link" href="#">
                              1
                            </a>
                          </li>
                          <li className="page-item active">
                            <a className="page-link" href="#">
                              2 <span className="sr-only">(current)</span>
                            </a>
                          </li>
                          <li className="page-item">
                            <a className="page-link" href="#">
                              3
                            </a>
                          </li>
                          <li className="page-item">
                            <a className="page-link" href="#">
                              Next
                            </a>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminLanguages;
